import {EMPTY} from 'rxjs';

import {Injector} from '@angular/core';
import {LoaderService, ToastService} from '@utils';

import {ApiError, ApiErrorObject} from './api-error.types';

export class ApiErrorModel extends Error implements ApiError {
	apiErrorObject: ApiErrorObject;

	constructor(init: Partial<ApiErrorModel>) {
		const message = init?.message || init?.apiErrorObject?.errorMessage || 'An error occurred';
		super(message);
		Object.assign(this, init);
	}

	public static fromErrorObject(error: any): ApiErrorModel {
		if (error instanceof TypeError && error.message === 'Importing a module script failed.') {
			return new ApiErrorModel({message: 'Failed to load required module'});
		}
		return new ApiErrorModel({
			apiErrorObject: error,
			message: error?.message || 'An error occurred',
			status: error?.status || error?.status_code || 500,
			url: error?.url || location.href,
			method: error?.method || 'X',
			...error,
		});
	}

	toJSON() {
		return {
			message: this.message,
			stack: this.stack,
			apiErrorObject: this.apiErrorObject,
		};
	}

	static showToast(errorObject: ApiErrorObject, injector: Injector) {
		const toastService = injector.get(ToastService);
		const loaderService = injector.get(LoaderService);
		toastService?.open({
			message: errorObject.userMessage,
			type: 'error',
		});
		loaderService?.hideLoader();
		return EMPTY;
	}
}
